/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nsc-form-field-autocomplete[_ngcontent-%COMP%]{position:relative}.nsc-form-field-autocomplete[_ngcontent-%COMP%]   .mat-card[_ngcontent-%COMP%]{position:absolute;top:100%;width:100%;padding:0;z-index:1;max-height:256px;overflow:auto;-webkit-overflow-scrolling:touch}"];
export { styles as styles };
